export const AUTHENTICATE = 'Auth/AUTHENTICATE';
export const DELETE_AUTH_USER = 'Auth/DELETE_AUTH_USER';
export const GET_AUTH_USER = 'Auth/GET_AUTH_USER';
export const RESET_PASSWORD = 'Auth/RESET_PASSWORD';
export const SETUP_AUTHENTICATION = 'Auth/SETUP_AUTHENTICATION';
export const SET_AUTH_USER = 'Auth/SET_AUTH_USER';
export const UNAUTHENTICATE = 'Auth/UNAUTHENTICATE';
export const UPDATE_AUTH_USER = 'Auth/UPDATE_AUTH_USER';
